import React from 'react';
import {Row, Col } from "reactstrap";
import Carousel from "nuka-carousel";
import {
  getAdBannerByDomainAction
} from "../../../../Store/actions";
import {
  getRecommendBannerAction,
} from "../../../../Store/Coupons/actions";
import {useSelector, useDispatch} from "react-redux";
import { getImageUrl} from "../../../../Utils/index";

export default function Slider() {

  const dispatch = useDispatch();

  const {adBanners} = useSelector((state) => state.Website);
  const { getRecommendBanner } = useSelector(
      (state) => state.Coupon
    );

  const items = React.useMemo(()=>{
    let arr = [];
    adBanners?.forEach((i)=> {
      if(i.banner_dimension === "1480 * 630"){let obj = {};
            obj.src = getImageUrl(i.image_upload);
            obj.altText = "ad";
            if(!i.image_upload){
            obj.src = i.image_url;
            }
            arr.push(obj);}
    });
    return arr;
  }, [adBanners])

  const items2 = React.useMemo(()=>{
    let arr = [];
    getRecommendBanner?.forEach((i)=> {
      if(i.banner_dimension === "300 * 250"){let obj = {};
            obj.src = getImageUrl(i.image_upload);
            if(!i.image_upload){
            obj.src = i.image_url;
            }
            obj.altText = "ad";
            arr.push(obj);}
    });
    return arr;
  }, [getRecommendBanner])


  React.useEffect(() => {
    dispatch(getRecommendBannerAction({ dimension: "300 * 250" }));
  }, [dispatch]);

  React.useEffect(()=>{
      dispatch(getAdBannerByDomainAction());
  }, [dispatch])

  return(
    <div style={{display:"flex", alignItems:"center", justifyContent:"center", marginTop:"1vh"}}>
    <Row id="sliders-i3" style={{maxWidth:"1350px"}}>
    <Col sm="12" md="8" id="main-banner-i3">
    <div>
    <Carousel> 
      {items.map((o)=>{
        return(
  <img  className="cursor-pointer" onClick={()=>window.open(o?.redirect_url, "_blank")}
   id="slider-i3-rect" src={o.url || o.src} alt={o.alt}
   loading="lazy"
  style={{width:"100%"}}/>
  )
      })}
  </Carousel>
   </div>
    </Col>
    <Col sm="12" md="4">
    <div >
    <Carousel> 
      {items2.map((o)=>{
        return(
  <img  id="slider-i3-square-m"  className="cursor-pointer" onClick={()=>window.open(window.innerWidth > 768 ? o?.desktop_redirect_url : o?.mobile_redirect_url, "_blank")}
   src={o.url || o.src} alt={o.alt}
   loading='lazy'
  style={{width:"100%"}}/>
  )
      })}
  </Carousel>
   </div>
    </Col>
   </Row>
   </div>
)
}